import React, { useEffect, useState } from "react";
import { getSprachenPage } from "../lib/api";
import {
  Page,
  PageHeader,
  Section,
  SectionHead,
  IntroSplit,
  CardGrid,
  IconCard,
} from "../components/ui";

/**
 * Before: 94 lines of JSX + 213 lines of SprachenStaerkenPage.css
 * After:  this file, no page stylesheet at all.
 */
export default function SprachenStaerkenPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSprachenPage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    heroImage,
    introKicker,
    introTitle,
    introText,
    sectionTitle,
    sectionSubtitle,
    cards,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Lernwelt", to: "/lernen-und-verstehen" }}
        current="Sprachen stärken"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit
          image={heroImage}
          kicker={introKicker}
          title={introTitle}
          text={introText}
        />
      </Section>

      <Section>
        <SectionHead title={sectionTitle} subtitle={sectionSubtitle} />

        <CardGrid cols={3}>
          {(cards || []).map((card, i) => (
            <IconCard
              key={card.id ?? i}
              iconName={card.iconName}
              title={card.title}
              text={card.text}
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}